import type { ApiHelper, ApiResponseWithData, BaseRequest } from '..';
import { ApiHelperWithData, splitParams } from '..';
import type {
  MstIprmCreateParams,
  MstIprmDetailResponse,
  MstIprmImageUploadResponse,
  MstIprmSearchParams,
  MstIprmSearchRow,
  MstIprmUpdateParams,
} from '../model/MstIprm';
import type { ApndUploadedFile } from '../model/ApendFiles';
import type { PagerData } from '../model/PagerData';

export class MstIprmApi {
  private withData: ApiHelperWithData;
  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  /**
   * 인력정보를 등록한다.
   */
  create = (
    params: MstIprmCreateParams & BaseRequest,
  ): Promise<ApiResponseWithData<{ result: number }>> => {
    const url = '/api/mst-iprm/create';
    return this.withData.postJson(url, ...splitParams(params));
  };

  /**
   * 파일 붙여넣기 후 이미지 임시 저장
   * @param 파일
   * @returns
   */
  uploadAttachment = (
    params: { file: File } & BaseRequest,
  ): Promise<ApiResponseWithData<ApndUploadedFile>> => {
    const url = '/api/mst-iprm/files/temp';
    const [data, extra] = splitParams(params);
    const formData = new FormData();
    formData.append('file', data.file, data.file.name);

    return this.withData.postMultipart(url, formData, extra);
  };

  deleteTempAttachment = (
    params: { fileId: string } & BaseRequest,
  ): Promise<ApiResponseWithData<void>> => {
    const url = '/api/mst-iprm/files/temp/delete';
    return this.withData.postJson(url, ...splitParams(params));
  };

  uploadImage = (
    params: { file: File } & BaseRequest,
  ): Promise<ApiResponseWithData<MstIprmImageUploadResponse>> => {
    const url = '/api/mst-iprm/images/temp';
    const [data, extra] = splitParams(params);
    const formData = new FormData();
    formData.append('file', data.file, data.file.name);

    return this.withData.postMultipart(url, formData, extra);
  };

  search = (
    params: MstIprmSearchParams & BaseRequest,
  ): Promise<ApiResponseWithData<{ pagerData: PagerData<MstIprmSearchRow> }>> => {
    const url = '/api/mst-iprm/search';
    return this.withData.postJson(url, ...splitParams(params));
  };

  detail = (
    params: { iprmId: string } & BaseRequest,
  ): Promise<ApiResponseWithData<{ detail: MstIprmDetailResponse }>> => {
    const url = '/api/mst-iprm/detail';
    return this.withData.postJson(url, ...splitParams(params));
  };

  update = (
    params: MstIprmUpdateParams & BaseRequest,
  ): Promise<ApiResponseWithData<{ result: number }>> => {
    const url = '/api/mst-iprm/update';
    return this.withData.postJson(url, ...splitParams(params));
  };

  delete = (
    params: { iprmId: string } & BaseRequest,
  ): Promise<ApiResponseWithData<{ result: number }>> => {
    const url = '/api/mst-iprm/delete';
    return this.withData.postJson(url, ...splitParams(params));
  };
}
